import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
  min-width: 0;
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-200']};
  text-align: center;
`;

export const MetaText = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.secondary};
  margin: 0;
`;

export const FilterNote = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  margin: 0;
  padding-top: ${space['space-300']};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
  gap: ${space['space-300']};
  width: 100%;
`;

export const ErrorRow = styled.div`
  display: flex;
  justify-content: center;
`;
